import { Navigate } from 'react-router-dom';
import { IRoute, PortalRoutePath } from '@models';
import { Permission } from '@services';
import { AllQuotation } from './AllQuotation';

export const QUOTATION_ROUTES: IRoute = {
	path: PortalRoutePath.QUOTATION,
	hideFromMenu: true,
	canActivate: (_route, user) => !!user?.hasPermission([Permission.QUOTATION_READ, Permission.QUOTATION_WRITE]),
	children: [
		{
			path: '',
			element: <AllQuotation />
		},
		{
			index: true,
			path: '*',
			hideFromMenu: true,
			element: <Navigate to={{ pathname: '/portal' }} replace />
		}
	]
};
